import { FC, MouseEvent } from 'react';
import { trackEvent } from 'dibs-tracking';
import { learnMore } from '../../pdpMessages';
import { graphql, useFragment } from 'react-relay';

// components
import {
    Vetted,
    Support,
    Delivery,
    PriceMatch,
    Confidence,
    Protection,
} from './PdpRespSharedBuyerAssuranceBenefits';
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';

// styles
import styles from './PdpRespSharedBuyerAssurance.scss';

// type
import { PdpRespSharedBuyerAssurance_user$key as User } from './__generated__/PdpRespSharedBuyerAssurance_user.graphql';

// constants
const LINK_BUYER = '/about/promise/';
const LINK_TRADE = '/info/trade/promise/';

const trackLearnMore = (event: MouseEvent): void =>
    trackEvent(
        {
            action: 'buyer protection',
            label: 'clicked',
            category: 'product',
            value: 0,
        },
        event
    );

const userFragment = graphql`
    fragment PdpRespSharedBuyerAssurance_user on User {
        isVerifiedTrade
    }
`;

export const PdpRespSharedBuyerAssurance: FC<{ user: User | null }> = ({ user: userRef }) => {
    const user = useFragment(userFragment, userRef);
    const learnMoreLink = user?.isVerifiedTrade ? LINK_TRADE : LINK_BUYER;

    return (
        <div className={styles.wrapper}>
            <div>
                <HeadingLevel>
                    {Header => (
                        <Header className={styles.header}>
                            <FormattedMessage
                                id="PdpRespSharedBuyerAssurance.header"
                                defaultMessage="The 1stDibs Promise"
                            />
                        </Header>
                    )}
                </HeadingLevel>

                <Link href={learnMoreLink} onClick={trackLearnMore} className={styles.learnMore}>
                    {learnMore}
                </Link>
                <div className={styles.benefits}>
                    <div className={styles.benefitColumn}>
                        {Vetted}
                        {Confidence}
                    </div>
                    <div className={styles.benefitColumn}>
                        {PriceMatch}
                        {Support}
                    </div>
                    <div className={styles.benefitColumn}>
                        {Protection}
                        {Delivery}
                    </div>
                </div>
            </div>
        </div>
    );
};
